



















































import {Component, Inject} from "vue-property-decorator";
import SioReg from "../sio/SioReg.vue";
import rd from "../../modules/vRoutedefs";
import Api from "./Api";
import UserRequired from "../UserRequired";
import AppRedirector from "@/components/shared/AppRedirector.vue";
import {DateTime, IdCard} from "@/modules/models";
import CardIcon from "@/components/CardIcon.vue";
import {DefaultColor, ErrorColor, WarningColor} from "@/modules/constants";

@Component({
    components: {
        "at-sio-reg": SioReg,
        "at-appredirector": AppRedirector,
        "at-card-icon": CardIcon,
    }
})
export default class UserOverview extends UserRequired {
    @Inject()
    api!: Api;

    cardAddDismissed = false;
    get missingCard() {
        return !(this.cardAddDismissed || this.baseApi.config.cardAddDismissed || this.user.cards.length > 0);
    }
    get cardAddAvailable() {
        return this.baseApi.config.qrCardConnectAvailable;
    }

    get cardAddTo() {
        return {path: rd.start.card.add.path};
    }

    // Return newest card user has, if it is expired, deactivated or soon expired. We'll then show a notification to get used to connect new card.
    get needNewCard(): IdCard | null {
        if(this.cardAddDismissed || this.baseApi.config.cardAddDismissed) {
            return null; // Short circuit, user has discarded notification.
        }
        let oldCard: IdCard | null = null;
        for(let card of this.user.cards) {
            if(card.isSoonExpired() || card.isDeactivated()) {
                if(oldCard == null || oldCard.expirationDate.isBefore(card.expirationDate)) {
                    oldCard = card;
                }
            } else {
                return null; // Short circuit, user has active card
            }
        }
        return oldCard;
    }

    get needNewCardColor() {
        if(this.needNewCard != null) {
            return this.needNewCard.isExpired() || this.needNewCard.isDeactivated() ? ErrorColor : WarningColor;
        }
        return DefaultColor;
    }

    shouldInstallApp = false;

    onShouldInstallAppChange(v: boolean) {
        this.shouldInstallApp = v;
    }

    async cardAddLater() {
        this.cardAddDismissed = true;
        await this.api.dismissCardAdd();
        this.baseApi.loadConfig();
    }

}
